import { useCallback } from 'react';
// eslint-disable-next-line no-restricted-imports
import { useOpenDialog } from '../../../../../routing/ModalRoute';
// eslint-disable-next-line no-restricted-imports
import { DIALOGS } from '../../../../../routing/constants';
import { isBloggerOwner } from '../../../../../utils/accessService';
import { pluralize } from '../../../../../utils/pluralize';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { ProfileStatItem } from '../ProfileStatItem/ProfileStatItem';
import { ProfileStatProps } from './types';

export const ProfileStat = ({ business, user }: ProfileStatProps) => {
    const openDialog = useOpenDialog();

    const { posts = 0, subscribers = 0 } = business;
    const userSubscriptions = user?.subscriptions ?? 0;

    const separator = (
        <Typography variant="body2" weight="medium">
            •
        </Typography>
    );

    const onShowSubscriptions = useCallback(() => {
        openDialog(DIALOGS.SUBSCRIPTIONS);
    }, [openDialog]);

    return (
        <Flex direction="row" spacing={0.75}>
            <ProfileStatItem value={posts} label={pluralize(posts, 'пост', 'поста', 'постов')} />
            {business.subscribers ? (
                <>
                    {separator}
                    <ProfileStatItem
                        value={subscribers}
                        label={pluralize(subscribers, 'подписчик', 'подписчика', 'подписчиков')}
                    />
                </>
            ) : null}
            {isBloggerOwner(business, user) && (
                <>
                    {separator}
                    <ProfileStatItem
                        value={userSubscriptions}
                        label={pluralize(userSubscriptions, 'подписка', 'подписки', 'подписок')}
                        onClick={onShowSubscriptions}
                    />
                </>
            )}
        </Flex>
    );
};
